import * as React from "react";
 const Loader = ({ isLoading, fullScreen }) => (
  isLoading ? <div className={`loader-overlay ${fullScreen ? "fullscreen" : ""}`}><div className="loader"></div></div> : null);

export default Loader;